var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "damage-validation view" }, [
    _c("div", { staticClass: "view_content" }, [
      _c("div", { staticClass: "view_content_markdown" }, [
        _c("h1", [_vm._v(_vm._s(_vm.title))]),
        _c("p", [_vm._v(_vm._s(_vm.text1))]),
        _c("h3", { staticClass: "damage-validation_compensation" }, [
          _vm._v(
            _vm._s(
              _vm.$t("damageValidation.amount", {
                amount: _vm.stateWarrantyResultDeclaration,
              })
            )
          ),
        ]),
        _c(
          "div",
          { staticClass: "report mg mg--b-2 grid grid--middle" },
          [
            _c("svgicon", {
              staticClass: "mg",
              attrs: {
                icon: "ico-file",
                height: "24",
                width: "24",
                color: "#7E8994",
              },
            }),
            _c("p", { staticClass: "mg" }, [
              _vm._v(_vm._s(_vm.$t("damageValidation.materialsList"))),
            ]),
            _c("svgicon", {
              staticClass: "mg",
              attrs: {
                icon: "ico-download",
                height: "24",
                width: "24",
                color: "#7E8994",
                "qa-downloadMaterialList-button": "",
              },
              on: { click: _vm.handleClickMaterialList },
            }),
          ],
          1
        ),
        _c("p", { staticClass: "mg mg--t-4" }, [_vm._v(_vm._s(_vm.text2))]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "view_actions" },
      [
        _c(
          "ma-buttons-next-actions",
          {
            staticClass: "buttonsNextActions",
            attrs: {
              handleButtonClick: _vm.handlePrimaryButtonClick,
              handleButtonClickWhiteBtn: _vm.handleSecondaryButtonClick,
              title: _vm.$t("damageValidation.actions.primary"),
              titleWhiteBtn: _vm.$t("damageValidation.actions.secondary"),
              btnType: "functionalBtnWhite",
            },
          },
          [
            _vm.isE2EFlow
              ? _vm._t("default", function () {
                  return [
                    _c(
                      "button",
                      {
                        staticClass: "btn mainWhite",
                        on: { click: _vm.handleTertiaryButtonClick },
                      },
                      [
                        _c("p", { staticClass: "text-medium" }, [
                          _vm._v(
                            _vm._s(_vm.$t("damageValidation.actions.tertiary"))
                          ),
                        ]),
                      ]
                    ),
                  ]
                })
              : _vm._e(),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }